import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { RoleSelectorService } from '@marketing/services/role-selector.service';
import { PageContainerComponent } from '@pages/page-container/page-container.component';
import { IUserProfile } from '@services/profile.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoutingGuardService
  implements CanDeactivate<PageContainerComponent> {
  public profile: IUserProfile = null;
  constructor(private roleSelectorService: RoleSelectorService) {}

  /**
   * This function is used to trigger Personalization Modal when navigating away from pages
   * inspired by this example: https://tobiasljungstrom.net/blog/2019-07-24-angular-route-guard-dialog/
   */
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.roleSelectorService.getCanDeactivate();
  }
}
